import IsurerLayout from '@layouts/IsurerLayout';
import InsuranceLayout from '@layouts/InsuranceLayout';
import MedicalLayout from '@layouts/MedicalLayout';
import React, { lazy } from 'react';
import RouterRender from '../routerRender';
import R from './Router';
import LoginLayout from '@layouts/LoginLayout';
import HomeWebSelectInsurance from '@pages/IsurerComponent/HomeWebSelectInsurance';
import RequestedHistory from '../../pages/IsurerComponent/RequestedHistory';
import DashboardMedicalLayout from '@layouts/DashboardMedicalLayout';
import Dashboard from '@pages/InsuranceComponent/Dashboard';
import SuperAdminLayout from '@layouts/SuperAdminLayout';
import HomeStatusAgent from '../../pages/InsuranceComponent/HomeStatusAgent';

// const Home = lazy(() => import('@pages/Home'));
// const LoginType = lazy(() => import('../../pages/AllSetting/LoginType'));
const LoginDashboardMedical = lazy(() => import('../../pages/DashboardMedComponent/LoginDashboardMedical'));
const DashboardMedical = lazy(() => import('../../pages/DashboardMedComponent/DashboardMedical'));
const Login = lazy(() => import('../../pages/Login'));
const HomeSelect = lazy(() => import('../../pages/IsurerComponent/HomeSelectInsurance'));
const HomeConsent = lazy(() => import('../../pages/IsurerComponent/HomeListConsent'));
const Homestate = lazy(() => import('../../pages/InsuranceComponent/HomeStatus'));
const HomeConsentSuccess = lazy(() => import('../../pages/InsuranceComponent/HomeListConsentSuccess'));
const HomeAgent = lazy(() => import('../../pages/InsuranceComponent/HomeWebInsuranceAgent'));
const HomeListAgent = lazy(() => import('../../pages/InsuranceComponent/HomeWebListAgent'));
const DashboardLoading = lazy(() => import('../../pages/AllSetting/DashboardLoading'));
const HomeMedPending = lazy(() => import('../../pages/MedicalComponent/HomeMedPending'));
// const Homestatusagent = lazy(() => import('../../pages/InsuranceComponent/HomeStatusAgent'));
const HomeWebstatus = lazy(() => import('../../pages/IsurerComponent/HomeWebStatus'));
const requestedhistory = lazy(() => import('../../pages/IsurerComponent/RequestedHistory'));
const HomeWebMedPending = lazy(() => import('../../pages/MedicalComponent/HomeWebMedPending'));
const HomeWebMedSuccess = lazy(() => import('../../pages/MedicalComponent/HomeWebMedSuccess'));
const ChoiceForgetPassword = lazy(() => import('../../pages/AllSetting/ChoiceForgetPassword'));
const NewPasswordLogin = lazy(() => import('../../pages/AllSetting/NewPasswordLogin'));
const SetNewPassword = lazy(() => import('../../pages/AllSetting/SetNewPassword'));
const SetForgetPasswordEmail = lazy(() => import('../../pages/AllSetting/SetForgetPasswordEmail'));
const SetForgetPasswordPhone = lazy(() => import('../../pages/AllSetting/SetForgetPasswordPhonenumber'));
const NewPasswordExpiredCode = lazy(() => import('../../pages/AllSetting/NewPasswordExpiredCode'));
const ManageData = lazy(() => import('../../pages/DashboardMedComponent/ManageData'));
const NewPasswordLoginUser = lazy(() => import('../../pages/AllSetting/NewPasswordLoginUser'));
const ManageUser = lazy(() => import('../../pages/SuperAdmin/ManageUser'));
const dashboardsuperadmin = lazy(() => import('../../pages/InsuranceComponent/Dashboard'));

const Router = (): any => [
  RouterRender([
    // {
    //   link: R.logintype.link,
    //   layout: (props): JSX.Element => (<>{props?.children}</>),
    //   component: LoginType,
    // },
    {
      link: R.login.link,
      layout: LoginLayout,
      component: Login,
    },
    {
      link: R.dashboardinsurance.link,
      layout: InsuranceLayout,
      component: Dashboard,
    },
    {
      link: R.logindashboardmedical.link,
      layout: LoginLayout,
      component: LoginDashboardMedical,
    },
    {
      link: R.dashboardMedical.link,
      layout: DashboardMedicalLayout,
      component: DashboardMedical,
    },
    {
      link: R.manageData.link,
      layout: DashboardMedicalLayout,
      component: ManageData,
    },
    {
      link: R.request.link,
      layout: IsurerLayout,
      component: HomeSelect,
    },
    {
      link: R.status.link,
      layout: IsurerLayout,
      component: Homestate,
    },
    {
      link: R.consent.link,
      layout: IsurerLayout,
      component: HomeConsent,
    },
    {
      link: R.consentsuccess.link,
      layout: MedicalLayout,
      component: HomeConsentSuccess,
    },
    {
      link: R.sendrequest.link,
      layout: InsuranceLayout,
      component: HomeAgent,
    },
    {
      link: R.confirmsuccess.link,
      layout: InsuranceLayout,
      component: HomeListAgent,
    },
    {
      link: R.medpending.link,
      layout: MedicalLayout,
      component: HomeMedPending,
    },
    {
      link: R.executionstatus.link,
      layout: InsuranceLayout,
      component: HomeStatusAgent,
    },
    {
      link: R.requestlist.link,
      layout: IsurerLayout,
      component: HomeWebSelectInsurance,
    },
    {
      link: R.requeststatus.link,
      layout: IsurerLayout,
      component: HomeWebstatus,
    },
    {
      link: R.requestedhistory.link,
      layout: IsurerLayout,
      component: RequestedHistory,
    },
    {
      link: R.medpendingweb.link,
      layout: MedicalLayout,
      component: HomeWebMedPending,
    },
    {
      link: R.medsuccessweb.link,
      layout: MedicalLayout,
      component: HomeWebMedSuccess,
    },
    {
      link: R.NewPasswordexpiredcode.link,
      layout: (props): JSX.Element => (<>{props?.children}</>),
      component: NewPasswordExpiredCode,
    },
    {
      link: R.newpasswordlogin.link,
      layout: InsuranceLayout,
      component: NewPasswordLogin,
    },
    {
      link: R.newpasswordloginUser.link,
      layout: IsurerLayout,
      component: NewPasswordLoginUser,
    },
    {
      link: R.choiceforgetpassword.link,
      layout: (props): JSX.Element => (<>{props?.children}</>),
      component: ChoiceForgetPassword,
    },

    {
      link: R.setnewpassword.link,
      layout: (props): JSX.Element => (<>{props?.children}</>),
      component: SetNewPassword,
    },
    {
      link: R.setforgetpasswordemail.link,
      layout: (props): JSX.Element => (<>{props?.children}</>),
      component: SetForgetPasswordEmail,
    },
    {
      link: R.setforgetpasswordphone.link,
      layout: (props): JSX.Element => (<>{props?.children}</>),
      component: SetForgetPasswordPhone,
    },
    {
      link: R.dashboardloading.link,
      layout: (props): JSX.Element => (<>{props?.children}</>),
      component: DashboardLoading,
    },
    {
      link: R.manageuser.link,
      layout: SuperAdminLayout,
      component: ManageUser,
    },
    {
      link: R.dashboardsuperadmin.link,
      layout: SuperAdminLayout,
      component: Dashboard,
    },

  ]),
].map((router: any) => router);

export default Router();
